export default __webpack_public_path__ + "static/media/mb-logo-white.62b412ba.png";